import { lazy, Suspense, useEffect } from "react";
import "./home.css";
import { LOCAL_IMAGES } from "../utils/localimages";
import { useDispatch, useSelector } from "react-redux";
import setAuthorizationToken, { landingPageEvent } from "../utils/commonFunction";
import { getApiCall, postApiData } from "../utils/services";
import { useState } from "react";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import { totalProduct } from "../Redux/actions";
import axios from "axios";
import CommonSlider from "../commonComponent/commonSlider";

import BasicTabs from "../commonComponent/Tabs";
import { useInView } from "react-intersection-observer";
import ComponentLoader from "../components/loader/ComponentLoader";
import NewFields from "./NewFields";
const NewLaunches = lazy(() => import("./NewLaunches"));
const Combos = lazy(() => import("./Combos"));
const Testimonials = lazy(() => import("./Testimonials"));
const Brands = lazy(() => import("./Brands"));
const Banner = lazy(() => import("./Banner"));


const filtersColors = {
  0: "bg-[#1779b5]",
  1: "bg-[#f9a64e]",
  2: "bg-[#e88282]"
}

const Home = () => {
  const { ref: newRef, inView: newInView } = useInView({ triggerOnce: true, rootMargin: '20px' });
  const { ref: hairRef, inView: hairInView } = useInView({ triggerOnce: true, rootMargin: '20px' });
  const { ref: faceRef, inView: faceInView } = useInView({ triggerOnce: true, rootMargin: '20px' });
  const { ref: skinRef, inView: skinInView } = useInView({ triggerOnce: true, rootMargin: '20px' });
  const { ref: comboRef, inView: comboInView } = useInView({ triggerOnce: true, rootMargin: '20px' });
  const { ref: testRef, inView: testInView } = useInView({ triggerOnce: true, rootMargin: '20px' });
  const { ref: brandsRef, inView: brandsInView } = useInView({ triggerOnce: true, rootMargin: '20px' });
  const { ref: bannerRef, inView: bannerInView } = useInView({ triggerOnce: true, rootMargin: '20px' });

  const checkedBrands = {
    Loreal: false,
    // Skinconyc: false,
    Argatin: false,
    // SpringH2O: false,
  }
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState({
    bestSeller: "All",
    newLaunches: "All",
    skinCare: "All",
    hairCare: "All",

  });
  const [products, setProducts] = useState({
    bestSeller: [],
    newLaunches: [],
    skinCare: [],
    hairCare: [],
    facialKit: [],
    combo: []

  })
  const [filteredProds, setFilteredProds] = useState({
    bestSeller: [],
    newLaunches: [],
    skinCare: [],
    hairCare: []
  })


  const handleFilter = (key, val) => {
    setActiveTab((tab) => ({
      ...tab,
      [key]: val
    }))
    setFilteredProds((prev) => ({
      ...prev,
      [key]: products[key]?.filter((elm) => elm.brand === val)
    }))
  };
  const getUniqueBrands = (prod) => {

    if (prod?.length === 0) return []

    return [...new Set(prod?.map((elm) => elm.brand))]
  }

  const tabFields = [
    {
      heading: "Best Sellers Across Brands",
      data: products?.bestSeller,
      bestSeller: true


    }

  ]
  const newArrFields = [{
    heading: "New Arrivals",
    data: filteredProds?.newLaunches,
    bestSeller: false,
    filters: filters(getUniqueBrands(products?.newLaunches), handleFilter, activeTab, "newLaunches")
  }]

  const hairFields = [
    {
      heading: "Shop Hair Care",
      data: filteredProds?.hairCare,
      filters: filters(getUniqueBrands(products?.hairCare), handleFilter, activeTab, "hairCare")


    },

  ]
  const skinFields = [
    {
      heading: "Shop Skin Care",
      data: filteredProds?.skinCare,
      filters: filters(getUniqueBrands(products?.skinCare), handleFilter, activeTab, "skinCare")



    },
  ]
  const facialFields = [
    {
      heading: "Shop Facial Kits",
      data: filteredProds?.facialKit,
      filters: filters(getUniqueBrands(products?.facialKit), handleFilter, activeTab, "facialKit")



    },
  ]
  const comboFields = [
    {
      heading: "Shop Combos",
      data: products?.combo,




    },
  ]

  const TRACKING_ID = "G-56Q0JTSZKG";
  ReactGA.initialize(TRACKING_ID);
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  const token = useSelector((store) => store.authReducer.userData?.token);
  useEffect(() => {
    if (token) {
      setAuthorizationToken(token);
    }
  }, []);



  const fetchCombo = () => {
    const data = {
      brands: checkedBrands,
    };
    postApiData(
      "user/getComboProducts",
      data,
      (resp) => {
        setProducts((prev) => ({
          ...prev,
          combo: resp
        }))


        // setFilteredProducts(resp);
      },
      (error) => {

      }
    );
  }



  useEffect(() => {
    const data = {};
    axios
      .post("https://prosaloncart.com/user/getCartDetails", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {


        dispatch(totalProduct(response.data.data[0]?.products));
      })
      .catch((error) => {
        // Handle error
      });
  }, []);




  useEffect(() => {
    getApiCall("user/getAllProductsForBestseller",
      (resp) => {
        setProducts((prev) => ({
          ...prev,
          bestSeller: resp
        }))

      },
      (error) => {

      }
    )
  }, [])
  useEffect(() => {
    if (newInView) {
      getApiCall("user/getAllProductsForNewArrivals",
        (resp) => {
          setProducts((prev) => ({
            ...prev,
            newLaunches: resp
          }))
          setFilteredProds((prev) => ({
            ...prev,
            newLaunches: resp
          }))

        },
        (error) => {

        }
      )

    }

  }, [newInView])
  const fetchHairCare = () => {
    const data = {
      brands: {
        "Loreal": false,
        "Skinconyc": false,
        "Argatin": false,
        "Spring H2O": false
      },


      "category": "Hair Care"
    }

    postApiData("user/getAllProducts", data, (res) => {
      setProducts((prev) => ({

        ...prev,
        hairCare: res
      }))
      setFilteredProds((prev) => ({
        ...prev,
        hairCare: res
      }))
      // setProductformdetail(callBack);
    }, () => {
    }, true);
  };
  const fetchSkinCare = () => {
    const data = {
      brands: {
        "Loreal": false,
        "Skinconyc": false,
        "Argatin": false,
        "Spring H2O": false
      },


      "category": "Skin Care"
    }

    postApiData("user/getAllProducts", data, (res) => {
      setProducts((prev) => ({

        ...prev,
        skinCare: res
      }))
      setFilteredProds((prev) => ({

        ...prev,
        skinCare: res
      }))
      // setProductformdetail(callBack);
    }, () => {
    }, true);
  };
  const fetchFacialKit = () => {
    const data = {
      brands: {
        "Loreal": false,
        "Skinconyc": false,
        "Argatin": false,
        "Spring H2O": false
      },
      subCategory: "Facial Kit",


    }

    postApiData("user/getAllProducts", data, (res) => {
      setProducts((prev) => ({

        ...prev,
        facialKit: res
      }))
      setFilteredProds((prev) => ({

        ...prev,
        facialKit: res
      }))
      // setProductformdetail(callBack);
    }, () => {
    }, true);
  };


  const newFields = [{
    img: [LOCAL_IMAGES.haircare1, LOCAL_IMAGES.haircare2],
    tabFields: hairFields,
    ref: hairRef,
    show: hairInView

  },
  {
    img: [LOCAL_IMAGES.skincare1, LOCAL_IMAGES.skincare2],
    tabFields: skinFields,
    ref: skinRef,
    show: skinInView
  },
  {
    img: [LOCAL_IMAGES.facial1, LOCAL_IMAGES.facial2],
    tabFields: facialFields,
    ref: faceRef,
    show: faceInView
  },

  ]

  useEffect(() => {
    landingPageEvent()
  }, [])

  useEffect(() => {
    if (hairInView) fetchHairCare();

  }, [hairInView])
  useEffect(() => {
    if (skinInView) fetchSkinCare();

  }, [skinInView])
  useEffect(() => {
    if (faceInView) fetchFacialKit();


  }, [faceInView])
  useEffect(() => {
    if (comboInView) fetchCombo();

  }, [comboInView])
  return (
    <div className="">
      <Helmet>
        <title>
          Buy Hair Care & Skin Care Products Online in India - Argatin Keratin &
          SkinCo.
        </title>
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=AW-16512616878"
        ></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-16512616878');
          `}
        </script>

        <meta
          name="description"
          content="Buy Hair Care Products Online in India. Argatin brings to You Goodness of Nature with Our Toxin Free Hair Products Such as Hair Oil, Mask, Shampoo, Conditioner."
        />
        <meta
          name="robots"
          content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
        />
        <link rel="canonical" href="https://prosaloncart.com/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Buy Hair Care Products Online in India - Argatin Keratin"
        />
        <meta
          property="og:description"
          content="Buy Hair Care Products Online in India. Argatin brings to You Goodness of Nature with Our Toxin Free Hair Products Such as Hair Oil, Mask, Shampoo, Conditioner."
        />
        <meta property="og:url" content="https://prosaloncart.com/" />
        <meta property="og:site_name" content="Pro Salon Cart" />
        <meta property="og:updated_time" content="2023-05-02T06:55:45+00:00" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Buy Hair Care & Skin Care Products Online in India - Argatin Keratin & SkinCo."
        />
        <meta
          name="twitter:description"
          content="Buy Hair Care & Skin Care Products Online in India. Argatin,Skin.Co brings to You Goodness of Nature with Our Toxin Free Hair Products Such as Hair Oil, Mask, Shampoo, Conditioner."
        />
        <meta name="twitter:label1" content="Written by" />
        <meta name="twitter:data1" content="Pro SalonCart" />
        <meta name="twitter:label2" content="Time to read" />
        <meta name="twitter:data2" content="Less than a minute" />
      </Helmet>
      <div className="relative   w-full xl:mt-28 mt-24 max-w-[100vw] overflow-hidden">

        <CommonSlider />
      </div>
      <div className="mx-auto w-full md:w-[95%] xl:w-[90%] overflow-x-hidden   bg-white ">
        <BasicTabs tabFields={tabFields} />
      </div>
      <div ref={newRef} className="mx-auto w-full md:w-[95%] xl:w-[90%] overflow-x-hidden   bg-white ">


        {newInView && <Suspense fallback={<ComponentLoader />}>
          <NewLaunches newArrFields={newArrFields} />
        </Suspense>}
      </div>

      {/* <div ref={newRef} className="mx-auto w-full md:w-[95%] xl:w-[90%] overflow-x-hidden   bg-white ">
        <BasicTabs tabFields={newArrFields} />
      </div> */}

      <NewFields newFields={newFields} />



      <div className="mt-[4rem]">
        <div>
          <picture>
            {/* Image for large screens */}
            <source
              srcSet={LOCAL_IMAGES.combo1}
              media="(min-width: 1024px)"
            />

            {/* Image for small screens */}
            <source
              srcSet={LOCAL_IMAGES.combo2}
              media="(max-width: 767px)"
            />
            {/* Fallback image */}
            <img
              src={LOCAL_IMAGES.combo1}
              alt="Responsive Display"
              className="w-full aspect-1570/480 lg:aspect-1440/200" />
          </picture>

        </div>
        <div ref={comboRef} className="mx-auto w-full   bg-white my-5 md:my-10">

          {comboInView && <Suspense fallback={<ComponentLoader />}>
            <Combos comboFields={comboFields} />
          </Suspense>}
        </div>

        {/* <div ref={comboRef} className="mx-auto w-full   bg-white my-5 md:my-10">
        <BasicTabs tabFields={comboFields} />
      </div> */}
      </div>
      <div ref={testRef} className="px-5 my-2 md:px-0">
        {testInView && <Suspense fallback={<ComponentLoader />}>
          <Testimonials />
        </Suspense>
        }
      </div>
      <div ref={brandsRef} className="my-2">
        {brandsInView && <Suspense fallback={<ComponentLoader />}>
          <Brands />
        </Suspense>}
      </div>

      <div ref={bannerRef} className="my-2">
        {
          bannerInView && <Suspense fallback={<ComponentLoader />}>
            <Banner />
          </Suspense>
        }


      </div>
    </div>
  );
};


const filters = (list, onClick, activeTab, name) => {
  return (
    <div className='flex items-center justify-center sm:items-start sm:justify-start gap-2 md:gap-5 my-[1rem]'>
      {list?.map((elm, index) => {
        return (
          <span onClick={() => onClick(name, elm)} className={` ${activeTab[name] === elm ? "active-tab" : ""} ${filtersColors[index]} font-Inter  text-white p-[14px] cursor-pointer w-[30%] whitespace-nowrap  md:w-[20%] lg:w-[15%] flex items-center justify-center text-[12px] leading-[1.1]`} key={index}>{elm}</span>
        )
      })

      }

    </div>
  )
}
export default Home;
